import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      errors: {} as any,
      considerUpdateStatus: true
    };
  },

  methods: {
    /**
     * Check if given input has error.
     * @return bool
     * @param input
     */
    hasError(input: string): boolean {
      if (this.considerUpdateStatus && this.updating) {
        return false;
      }

      return (
        this.isAllowedInput(input) &&
        typeof this.errors[input] !== "undefined" &&
        this.errors[input].length > 0
      );
    },

    /**
     * Return error of given input.
     * @param  input
     * @return string
     */
    getError(input: string): string {
      if (!this.isAllowedInput(input) || !this.hasError(input)) {
        return "";
      }

      return this.errors[input][0];
    },

    /**
     * Store errors.
     * @param errors
     */
    storeErrors(errors: Array<any> | string): void | boolean {
      let successfulStored = false;

      if (typeof errors !== "string") {
        for (const key in errors) {
          if (Object.prototype.hasOwnProperty.call(errors, key)) {
            successfulStored = true;
            break;
          }
        }

        if (successfulStored) {
          this.errors = errors;
        }
      }

      if (errors === "Unauthenticated.") {
        window.location.replace("/login");
        return;
      }

      return successfulStored;
    },

    /**
     * Reset errors on all inputs.
     */
    resetErrors() {
      for (let i = 0; i < this.validatedInputs.length; i++) {
        const allowedInput = this.validatedInputs[i];
        if (this.hasError(allowedInput)) {
          this.errors[allowedInput] = "";
        }
      }
    },

    /**
     * Check if given input is allowed.
     * @param  string  input
     * @return bool
     */
    isAllowedInput(input: string): boolean {
      return this.validatedInputs.indexOf(input) > -1;
    },

    /**
     * Check if there is at least one error.
     * @return bool
     */
    hasAtLeastOneError() {
      return this.errors.length > 0;
    }
  }
});
